import React from "react";
import { useTranslation } from "react-i18next";
import { FiX } from "react-icons/fi";

const FileInputWithRemove = ({
  field,
  accept,
  name,
  placeholder,
  className,
  showImagePreview = true,
}) => {
  const { t } = useTranslation();

  const inputClassName =
    className ||
    [
      "file-input-field",
      "border h-12 text-sm focus:outline-none block w-full px-3 rounded",
      "bg-gray-100 text-gray-700 border-gray-200",
      "dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600",
      "focus:ring-1 focus:ring-orange-400",
    ].join(" ");

  const showAsImage = showImagePreview && field.isImageFile && field.previewSrc;

  return (
    <div>
      <input
        ref={field.inputRef}
        className={inputClassName}
        name={name}
        type="file"
        accept={accept}
        placeholder={placeholder}
        onChange={field.handleChange}
      />

      {field.hasPreview && (
        <div className="mt-2 flex flex-wrap items-start gap-3">
          {showAsImage ? (
            <img
              src={field.previewSrc}
              alt=""
              className="file-input-preview object-contain rounded border border-gray-200 dark:border-gray-600"
            />
          ) : (
            <span className="text-sm text-gray-600 dark:text-gray-300 break-all">
              {field.fileName}
            </span>
          )}

          <button
            type="button"
            onClick={field.handleRemove}
            className="inline-flex items-center text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 text-sm font-medium"
            title={t("MainModalRemove")}
          >
            <FiX className="w-4 h-4 mr-1" />
            {t("MainModalRemove")}
          </button>
        </div>
      )}
    </div>
  );
};

export default FileInputWithRemove;
